import React, { useContext } from "react";
import { useQuery } from "@apollo/client";
import MUIDataTable from "mui-datatables";
// import { Button } from "semantic-ui-react";
import { AuthContext } from "../context/auth";
import { FETCH_PLAYERS_QUERY } from "../util/graphql";
// import AddModal from "../components/AddModal";
// import { Button, Image, Modal } from "semantic-ui-react";

const TableAttributes = require("../variables/TableAttributes.js");

function Board() {
  const { user } = useContext(AuthContext);
  // let newData = [{}];
  const { loading, error, data } = useQuery(FETCH_PLAYERS_QUERY);

  if (loading) return "Loading...";
  if (error) return `Error! ${error.message}`;
  if (data) {
    // console.log(data.getPlayers);
  }
  // let add_button = (
  //   <Button.Group basic size="small">
  //     <Button icon="download" />
  //   </Button.Group>
  // );
  console.log(data.getPlayers);
  const editable = data.getPlayers.map((o) => ({
    ...o,
    fangraphs: o.playerId ? (
      <a href={`https://www.fangraphs.com/statss.aspx?playerid=${o.playerId}`}>
        {" "}
        Player Page{" "}
      </a>
    ) : (
      ""
    ),
  }));

  return (
    <div>
      {user && (
        <MUIDataTable
          title={
            <a href={`https://www.fangraphs.com/prospects/the-board/`}>
              Fangraphs Big Board
            </a>
          }
          data={editable}
          columns={TableAttributes.columns}
          options={TableAttributes.options}
        />
      )}
    </div>
  );
}

export default Board;
